import { defineStore } from 'pinia'
import type { Product, ProductWithInfo } from '@/types/product'
import type { AIShadowProperties } from '@/types/aiShadows'

interface productState {
  products: Product[]
  selectedProducts: Product[]
  baseProducts: Product[]
}

export const useProductStore = defineStore('product', {
  state: (): productState => ({
    products: [],
    selectedProducts: [],
    baseProducts: [],
  }),
  actions: {
    setProducts(products: Product[]): void {
      this.products = [...products]
    },
    setBaseProducts(products: Product[]): void {
      this.baseProducts = [...products]
    },
    addProduct(product: Product): void {
      this.products.push(product)
    },
    setSelectedProducts(products: Product[]): void {
      this.selectedProducts = [...products]
    },
    resetProductState(): void {
      this.selectedProducts = []
      this.products = []
    },
    storeShadowProperties(productId: number, shadowProperties: AIShadowProperties): void {
      const product = this.selectedProducts.find((p) => p.id === productId) as ProductWithInfo

      if (product) {
        product.productInfo.shadowInfo = shadowProperties
      }
    }
  },
})
